const locale = {
	pageTitle: '負責任礦產採購政策 | 擎億精密有限公司',
	pageDesc:
		'擎億精密負責任礦產採購政策。遵循 RBA 與 OECD 盡職調查指南，確保錫、鉭、鎢、金（3TG）等金屬來源無衝突且可追溯，要求供應商回覆 CMRT／EMRT 並簽署無衝突金屬宣告書。',
	pageKeywords:
		'負責任礦產採購政策, 衝突礦產, 3TG, RBA, OECD 盡職調查, CMRT, EMRT, 無衝突金屬宣告書, 擎億精密',
	title: '負責任礦產採購政策',
	subtitle: 'Responsible Minerals Sourcing Policy',
	clickHint: '點擊圖片可放大檢視',
	intro:
		'為落實負責任的礦產採購方式，支持人權與永續發展，擎億精密有限公司承諾遵循責任商業聯盟（RBA）之標準，並持續監督與改善與衝突礦產來源相關之議題。擎億精密避免直接或間接資助位於衝突影響與高風險地區之非法組織，確保錫（Tin）、鉭（Tantalum）、鎢（Tungsten）、金（Gold）（3TG），以及鈷（Cobalt）、雲母（Mica）、石墨（Graphite）、鋰（Lithium）、鎳（Nickel）與其他金屬之來源符合本政策要求且可追溯。',
	commitLead: '為此，擎億精密做出以下承諾：',
	sections: [
		{
			heading:
				'一、依循經濟合作與發展組織（OECD）發布之《衝突影響與高風險地區礦產供應鏈盡職調查指南》，採行可被稽核與驗證之盡職調查框架；並：',
			items: [
				'要求供應商回覆責任礦產倡議（RMI）的 CMRT（Conflict Minerals Reporting Template）與 EMRT（Extended Minerals Reporting Template）揭露表單。',
				'據以審閱、彙整與保存資料，持續進行供應鏈風險監測與管理。'
			]
		},
		{
			heading:
				'二、清楚溝通並要求供應商確保產品中金屬之來源可追溯且符合本政策，以確保整體供應鏈免於衝突礦產。',
			items: []
		},
		{
			heading: '三、透過以下方式落實供應鏈的衝突礦產管理：',
			items: [
				'制定衝突礦產政策。',
				'不購買從衝突地區來的衝突礦物。',
				'要求供應商簽署《無衝突金屬宣告書》。'
			]
		}
	],
	footnote:
		'要求供應商提供的原物料中不得間接或直接使用衝突礦產，必須遵循無衝突礦物的要求。如發現供應商之產品中有使用衝突礦產時，將採取必要措施停止使用該等衝突礦產。',
	company: '擎億精密有限公司',
	companyEn: 'QingYi Precision Co., Ltd.'
};

export default locale;
